<template>
    <div class="container">
        <div class="content">
            <div class="title">{{currentTitle}}</div>
            <div class="left_top">
                <div class="panel">
                    <div class="panel_h" style="font-size:5rem;">
                        <div class="panel_tr clearfix">
                            <span class="tab_left">时间</span>
                            <span class="tab_center">用途</span>
                            <span class="tab_right">项目名称</span>
                        </div>
                        <div class="maquee">
                            <ul class="today_ul">
                                <el-carousel height="600px" direction="vertical" :autoplay="true" indicator-position="none" :interval="10000">
                                    <el-carousel-item v-for="(ite,ind) in allCarousel" :key="ind">
                                        <li v-for="(item,index) in smallScreenData.slice(ind*pageSize,ind*pageSize+pageSize)"
                                            :key="index">
                                            <span class="tab_left">{{item.openTime}}</span>
                                            <span class="tab_center">{{item.filedTypeName}}</span>
                                            <span class="tab_right">{{item.businessName}}</span>
                                        </li>
                                    </el-carousel-item>
                                </el-carousel>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                smallScreenData:[],
                currentTitle:'市公共资源交易中心',
                allCarousel:[],
                pageSize:3,
            }
        },
        created() {
            this.getSmallScreenData();
            this.getSmallScreenTitle();
        },
        mounted() {

        },
        methods:{
            getSmallScreenData(){
              let url = window.location.href;
              let param=url.split('?')[1];
              if (!param){
                param="roomCode="
              }
                this.$http.get('/portal/getSmallScreenListByDate?'+param).then(res=>{
                    if(res.data.code == 1 && res.data.data.length > 0){
                        this.smallScreenData = res.data.data;
                        if(this.smallScreenData.length/this.pageSize == 0){
                            this.allCarousel.push('1');
                        }else{
                            for(var i = 0 ; i < Math.ceil(this.smallScreenData.length/this.pageSize) ; i++){
                                this.allCarousel.push(i);
                            }
                        }
                    }
                })
            },
            getSmallScreenTitle(){
                let url = window.location.href;
                let param=url.split('?')[1];
                if (!param){
                  param="roomCode="
                }
                this.$http.get('/portal/getScreenNameByCode?'+param).then(res=>{
                  this.currentTitle = res.data.data||'市公共资源交易中心';
                })
            }
        }
    }
</script>
<style scoped>


    *{
        margin:0px;
        padding:0px;
        font-family:'微软雅黑';
        -webkit-tap-highlight-color:rgba(0,0,0,0);
        box-sizing: border-box;
        letter-spacing: 4px;
        font-weight: normal;
    }
    .container{
        width: 100%;
        height: 100%;
        font-size: 90%;
    }
    li{
        list-style:none
    }
    img{
        border:none
    }
    a{
        text-decoration:none;
    }
    /deep/.el-carousel{
        overflow-x: inherit;
        overflow-y: hidden;
    }
    /deep/.el-carousel__item.is-animating{
        transition: opacity .3s ease-in-out !important;
    }
    .clearfix:after{
        content:" ";
        clear:both;
        height:0;
        visibility:hidden;
        display:block;
    }
    .content{
        width: 100%;
        height: 100%;
        background: #000;
        background-size:cover;
        background-attachment: fixed;
        color: #fff;
        padding: 7% 0.5% 3% 0.5%;
        font-size: 1.4rem;
        position: relative;
        overflow: hidden;
    }
    .left_top{
        width: 100%;
        height: 100%;
    }

    .panel{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .angle_1{
        position: absolute;
        width: 3%;
        height: 4%;
        top:0;
        left: 0;
        width: 32px;
        height: 32px;
        background: url(/Themes/Default/images/j1-ss.png) no-repeat;
    }
    .angle_2{
        position: absolute;
        width: 3%;
        height: 4%;
        top:0;
        right: 0;
        width: 32px;
        height: 32px;
        background: url(/Themes/Default/images/j2-ss.png) no-repeat;
    }
    .angle_3{
        position: absolute;
        width: 3%;
        height: 4%;
        bottom:0;
        left: 0;
        width: 32px;
        height: 32px;
        background: url(/Themes/Default/images/j4-ss.png) no-repeat;
    }
    .angle_4{
        position: absolute;
        width: 3%;
        height: 4%;
        bottom:0;
        right: 0;
        width: 32px;
        height: 32px;
        background: url(/Themes/Default/images/j3-ss.png) no-repeat;
    }
    .title{
        text-align: center;
        font-size: 5rem;
        position: absolute;
        top: 3%;
        width: 100%;
        color: #ffcb35;
        margin-left:-0.5%
    }
    .panel_h{
        height: 100%;
        overflow: hidden;
        padding:5px;
    }
    .panel_tr{
        border: 2px #b0b0b0 solid;
        color: #ff6d22;
        display: flex;
    }
    .tab_left{
        width: 15%;
        padding: 5px;
        text-align: center;
    }
    .tab_center{
        display: block;
        float: left;
        width: 15%;
        padding: 5px;
        text-align: center;
        border-left: 2px #b0b0b0 solid;
        margin-left: -2px;
    }
    .tab_right{
        display: block;
        float: left;
        border-left: 2px #b0b0b0 solid;
        margin-left: -2px;
        width: 70%;
        padding: 5px;
        text-align: center;
    }
    .maquee{
        margin-top: -2px;
        overflow: hidden;
    }
    .today_ul li{
        border-bottom: 2px #b0b0b0 solid;
        border-left: 2px #b0b0b0 solid;
        border-right: 2px #b0b0b0 solid;
        color: #ffcb35;
        display: flex;
    }
    .text{
        font-size: 1.6rem;
        display: inline-block;
        margin-bottom: 0.7%;
        width: 80%;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .w95{
        width: 95%;
    }
    .text_all{
        font-size: 1.6rem;
        display: inline-block;
        margin-bottom: 0.7%;
    }
    .content_right{
        float: right;
    }
    .content_left{
        float: left;
        width: 33%;
    }
    .center{
        text-align: center;
    }
    .blue{
        color: #00cbfe;
    }


    #today_list{
        position: relative;
    }
    #today_list .today_ul{
        position: absolute;
        width: 100%;
        opacity: 0;
    }
    #today_list .today_ul:first-child{
        opacity: 1;
    }
</style>